import { createContext } from "react";
import { TreeStore } from "../../store";

export const TreeContext = createContext<TreeStore | null>(null);
